import { Button } from "@mui/material";
import { CircledCheck } from "../../assets/icons/CircledCheck";
import { InfoToolTip } from "../../assets/icons/InfoTooltip";
import { formatDate } from "./helpers";
import { RightArrow } from "../../assets/icons/TradeIdeaModal/RightArrow";
import { LeftArrow } from "../../assets/icons/TradeIdeaModal/LeftArrow";
import { useNavigate } from "react-router-dom";

type OverlayMessageProps = {
  setShowExecutedOverlay?: (show: boolean) => void;
  setShowErrorOverlay?: (show: boolean) => void;
  errorMessage?: string;
  errorType?: string;
};

enum OverlayMessageType {
  Preview = "preview",
}
const OverlayMessage = ({
  setShowExecutedOverlay,
  setShowErrorOverlay,
  errorMessage = "",
  errorType,
}: OverlayMessageProps) => {
  const navigate = useNavigate();

  const handleCloseOverlay = () => {
    if (errorMessage === "" && setShowExecutedOverlay) {
      setShowExecutedOverlay(false);
    }
    else if (setShowErrorOverlay) {
      setShowErrorOverlay(false);
    }
  };

  const handleNavigate = () => {
    navigate("/performance-dashboard");
  };

  return (
    <div
      className="fixed inset-0 flex flex-col gap-y-4 items-center justify-center bg-black bg-opacity-70 z-50 backdrop-blur rounded-lg"
      onClick={handleCloseOverlay}
    >
      {!errorMessage
        ? (
            <div className="flex flex-col items-center justify-center gap-y-4 p-6 rounded-lg">
              <CircledCheck className="text-mui-green-text-success" />
              <h6 className="text-white text-center">
                This order has been executed on
                {" "}
                {formatDate(new Date())}
                .
              </h6>
              <Button
                variant="contained"
                color="inherit"
                size="large"
                className="whiteButton"
                onClick={handleNavigate}
              >
                View order in Performance Dashboard
                <RightArrow className="ms-2" />
              </Button>
              <Button
                variant="outlined"
                size="large"
                color="inherit"
                className="whiteButton-outlined"
                onClick={handleCloseOverlay}
              >
                <LeftArrow className="me-2" />
                Back to Trade Ideas
              </Button>
            </div>
          )
        : (
            <div className="flex flex-col items-center gap-y-4">
              <div className="flex gap-x-3 bg-mui-alert-error-pink p-4 rounded w-[90%]">
                <InfoToolTip className=" text-mui-primary-red-light w-5 h-5 flex-shrink-0" />
                <div className="flex flex-col text-mui-alert-error-text flex-1">
                  <div className=" body1">
                    {errorType === OverlayMessageType.Preview ? "Unable to preview" : "Unable to execute"}
                  </div>
                  <div className="body2">
                    {errorMessage}
                  </div>
                </div>
              </div>
              <div className="body2 text-white">Click to close</div>
            </div>
          )}
    </div>
  );
};

export default OverlayMessage;
